import { EuiSpacer } from '@elastic/eui';
import SuccessBox from 'components/Web_User_Interface/1080p_Series/Smarthome/Alexa_Skill/SuccessBox';
import PrimaryBox from 'components/Web_User_Interface/1080p_Series/Smarthome/Alexa_Skill/PrimaryBox';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
import * as React from 'react';
export default {
  EuiSpacer,
  SuccessBox,
  PrimaryBox,
  BreadCrumbs,
  SEOHelmet,
  React
};